import axios from '@/utils/request'

// 考研经验库-列表获取
export function getList(year, params) {
    return axios.get('/admin_api/v1/query/experience/' + year + '/', {
      params
    })
}

// 考研经验库-获取详情
export function getDetail(uuid) {
    return axios.get('/admin_api/v1/query/experience/' + uuid + '/')
}

// 考研经验库-添加
export function add(year, data) {
    return axios.post('/admin_api/v1/query/experience/' + year + '/', data)
}
  
// 考研经验库-编辑
export function edit(uuid, data) {
    return axios.put('/admin_api/v1/query/experience/' + uuid + '/', data)
}
  
// 考研经验库-删除
export function del(uuid) {
    return axios.delete('/admin_api/v1/query/experience/' + uuid + '/')
}